import { useMemo } from 'react';

import { Preview } from '@/features/Dashboard/components/Preview';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';
import {
  BasicTableValues,
  ChartFormValues,
  TileValues
} from '@/features/Dashboard/form/AppForm/context/types';
import { getAppTemplateFromFormValues } from '@/features/Dashboard/form/AppForm/utils/getAppTemplateFromFormValues';

const FormPreviewContent = ({
  values,
  enabled
}: {
  values: ChartFormValues | BasicTableValues | TileValues | null;
  enabled: boolean;
}) => {
  const template = useMemo(() => {
    if (!values) return undefined;
    return getAppTemplateFromFormValues(values);
  }, [values]);
  return (
    <Preview
      enabled={enabled}
      template={template}
    />
  );
};

export const FormPreview = () => {
  const { form, canPreview } = useAppForm();
  return (
    <form.Subscribe selector={s => ({ values: s.values })}>
      {({ values }) => (
        <FormPreviewContent
          enabled={canPreview && !!values?.symbols?.active.length}
          values={values}
        />
      )}
    </form.Subscribe>
  );
};
